import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div className="error-boundary-screen">
          <AlertTriangle size={48} className="error-boundary-icon" aria-hidden="true" />
          <h2 className="error-boundary-title">Something went wrong</h2>
          <p className="error-boundary-sub">
            An unexpected error occurred. Reload the page — your work is safe.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
            style={{ marginTop: 8 }}
          >
            <RefreshCw size={14} aria-hidden="true" />
            Reload page
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre className="error-boundary-detail">
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
